import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
} from "react-router-dom";

import Layout from "../components/Layout";
import PrivateRoute from "./routeTypes/PrivateRoute";
import VerifiedRoute from "./routeTypes/VerifiedRoute";
import AdminRoute from "./routeTypes/AdminRoute";
import HelpCenterLayout from "../components/help/HelpCenterLayout";

import App from "../../App";
import NotFound from "../pages/notFound";
import {
  Confirmation,
  ConfirmEmail,
  CreatePassword,
  ExpiredLink,
  ForgotPassword,
  ResetPassword,
  OauthLogin,
  SignIn,
  SignUp,
} from "../pages/auth";
import { PaymentSuccess, Pricing } from "../pages/payment";
import { Profile } from "../pages/profile";
import { SetupIntentSuccess } from "../pages/profile/subscriptionRedirect";
import { ChangeEmailVerification } from "../pages/profile/emailChange";
import { Dashboard } from "../pages/dashboard";
import Docs from "../pages/docs";
import { Help, Feedbacks, FeedbackList, FeedbackObject } from "../pages/help";
import { ProjectList, SelectPlatform, Project } from "../pages/projects";
import { AllPostEditor, UpdatePostEditor } from "../pages/postEditor";
import ErrorLogs from "../pages/serverLogs/error_logs";
import Editor from "../pages/postEditor/Editor";
import PaymentCancelled from "../pages/payment/PaymentCancelled";
import TokenPurchaseSuccess from "../pages/payment/token-purchase-success";
import AuthLayout from "../pages/auth/AuthLayout";

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route path="/" element={<App />}>
      <Route path="*" element={<NotFound />} />

      {/* AUTHENTICATION */}
      <Route path="" element={<AuthLayout />}>
      <Route index element={<SignIn />} />
        <Route path="/login" element={<SignIn />} />
        <Route path="/signup" element={<SignUp />} />
        <Route path="/confirmation" element={<Confirmation />} />
        <Route path="/oauth-login" element={<OauthLogin />} />
        <Route path="/confirm-email/:token" element={<ConfirmEmail />} />
        <Route path="/expired-link" element={<ExpiredLink />} />
        <Route path="/create-password" element={<CreatePassword />} />
        <Route path="/change-email-confirmation/:token" element={<ChangeEmailVerification />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password/:id" element={<ResetPassword />} />
      </Route>

      {/* ROADMAP AND FEEDBACK */}
      <Route path="" element={<HelpCenterLayout />}>
        <Route path="/feedbacks" element={<Feedbacks />} />
        <Route path="/feedbacks/list" element={<FeedbackList />} />
        <Route path="/feedback/:id" element={<FeedbackObject />} />
      </Route>

      {/* PRIVEE */}
      <Route path="" element={<PrivateRoute />}>
        <Route path="" element={<VerifiedRoute />}>
          <Route path="" element={<Layout />}>
            <Route path="/profile" element={<Profile />} />
            <Route path="/help" element={<Help />} />
            <Route path="/add-payment-method" element={<SetupIntentSuccess />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/payment/cancelled" element={<PaymentCancelled />} />
            <Route path="" element={<AdminRoute />}>
              <Route path="/error-logs" element={<ErrorLogs />} />
            </Route>
            
              <Route path="/dashboard" element={<Dashboard />} />

              {/* PROJECTS */}
              <Route path="/projects/select-platform" element={<SelectPlatform />} />
              <Route path="/projects" element={<ProjectList />} />
              <Route path="/project/:id" element={<Project />} />

              {/* BLOG POSTS */}
              <Route path="/blog-posts" element={<AllPostEditor />} />
              <Route path="/docs" element={<Docs />} />

              {/* TOKEN PACKS */}
              <Route path="/token-pack-success" element={<TokenPurchaseSuccess />} />
          </Route>
            <Route path="/post-editor" element={<Editor />} />
            <Route path="/post-editor/:id" element={<UpdatePostEditor />} />
        </Route>
      </Route>
    </Route>
  )
);
export default router;
